import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { fromLonLat } from 'ol/proj.js';


import { useRuntimeStore } from "@/store/runtime"


export const degioz = {
  "4326": [45.5288945, 7.2013780],
  "3857": [801653, 5705172]
}

export const startingPosition = {
  coords: {
    accuracy: 10000,
    altitude: 0,
    altitudeAccuracy: 1000,
    heading: 0,
    latitude: degioz["4326"][0],
    longitude: degioz["4326"][1],
    speed: 0,
  },
  timestamp: Date.now().timestamp
}

const position = ref(startingPosition)
const age = ref(Date.now()) // 10 years


const degToRad = (deg) => {
  const rad = (deg * Math.PI / 180) % 360;
  // console.log("degToRad", deg, rad);
  return rad
}

const missed = ref({
  count: 0,
  last: null
});
const support = ref(false);

const geolocationOptions = {
  enableHighAccuracy: true,
  timeout: 2000,
  maximumAge: 500
};

const startGeoLocation = () => {

  clearInterval(activateGeolocationOnFirstInteractionInterval)

  if (navigator.geolocation) {
    console.log("📍 navigator.geolocation watchPosition")
    navigator.geolocation.watchPosition(success, error, geolocationOptions);
    support.value = true;
  } else {
    console.error("❌ navigator.geolocation error")
    support.value = false;
  }
}

const success = (positionJustGot) => {
  let devHeading = 0
  if (ENVIRONMENT === "development") {
    devHeading = Math.random() * 360
  }

  let newPosition = {
    coords: {
      accuracy: positionJustGot.coords.accuracy,
      altitude: positionJustGot.coords.altitude,
      altitudeAccuracy: positionJustGot.coords.altitudeAccuracy,
      heading: positionJustGot.coords.heading || devHeading,
      latitude: positionJustGot.coords.latitude,
      longitude: positionJustGot.coords.longitude,
      speed: positionJustGot.coords.speed,
    },
    timestamp: JSON.parse(JSON.stringify(positionJustGot.timestamp)),
  }

  // ignores non gps position
  if (newPosition.coords.accuracy > 10 || !newPosition?.coords?.heading) {
    // if accuracy is too low, or heading is not available, ignore the position just got
    missed.value.count += 1
    missed.value.last = newPosition
    // return

    // newPosition.coords.heading = Math.random() * 360
  }

  position.value = newPosition
  // console.log(position)
  // console.log(position.value)

}

const error = (err) => {
  // console.error(err);
  switch (err.code) {
    case 1:
      console.info("PERMISSION_DENIED");
      break;
    case 2:
      console.info("POSITION_UNAVAILABLE");
      break;
    case 3:
      console.info("TIMEOUT");
      break;
    default:
      console.error("UNKNOWN_ERROR");
      break;
  }
}


// startGeoLocation(); // without interval

const activateGeolocationOnFirstInteractionInterval = setInterval(() => {
  if ((navigator?.userActivation) && ("hasBeenActive" in navigator.userActivation)) {
    if (navigator.userActivation.hasBeenActive === true) {
      // proceed with auto-playing an animation, for example
      console.log("👆 navigator.userActivation hasBeenActive")
      startGeoLocation();
    }
  }
  else {
    console.log("❌ navigator.userActivation.hasBeenActive not supported")
    startGeoLocation();
  }
}, 2000)

setInterval(() => {
  // in seconds
  if (!position.value?.timestamp) return "-"
  age.value = parseInt((Date.now() - position.value.timestamp) / 1000)
}, 1000);



export const useLocationStore = defineStore("locationStore", {

  state: () => {

    const runtimeStore = useRuntimeStore();
    if (runtimeStore.session?.map?.location?.last) {
      position.value = runtimeStore.session.map.location.last
      console.log("📍 restored position (from session)")

    }

    return {
      support: support,
      position: position,
      age: age,
      missed: missed
    }
  },

  getters: {
    headingRad: (state) => {
      // random
      const rad = degToRad(state?.position?.coords?.heading || -1)
      // console.log("headingRad", rad);
      return rad
    },

    latLon4326: (state) => {

      if (!(state?.position?.coords?.longitude && state?.position?.coords?.latitude))
        return degioz["4326"]

      return [state.position.coords.latitude, state.position.coords.longitude]
    },
    coordinates3857: (state) => {

      if (!(state?.position?.coords?.longitude && state?.position?.coords?.latitude))
        return degioz["3857"]

      return fromLonLat([state.position.coords.longitude, state.position.coords.latitude])
    },
    coordinates32632: (state) => {

      if (!(state?.position?.coords?.longitude && state?.position?.coords?.latitude))
        return fromLonLat(degioz["4326"], 32632)
      return fromLonLat([state.position.coords.longitude, state.position.coords.latitude], 32632)
    },

  },

  actions: {

    byEPSG: function (epsg) {
      if (epsg == "EPSG:4326") return this.latLon4326
      if (epsg == "EPSG:3857") return this.coordinates3857
      if (epsg == "EPSG:32632") return this.coordinates32632
    }

  },

});
